export const SEND_AUDITORIA = "SEND_AUDITORIA";
export const SEND_AUDITORIA_DETALLE = "SEND_AUDITORIA_DETALLE";
